<template>
  <div>
    <breadcrumb :routerList="[{to:'/establish/rebate',title:'销售经理导入合同'},{title:'考核目标修改审批'}]"/>
    <div class="h-piece" style="margin:20px">
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>考核目标修改审批</h1>
        </div>
        <div class="h-formLine daoruhetong">
          <el-form ref="f" :model="f" label-position="right"
                   :inline="true"  class="demo-ruleForm h-formbLine">

            <el-form-item label="经销商名称" class="h-elformWrap-2">
              <el-input v-model="f.agentName" :v="f.agentName" style="width:3.2rem" readonly></el-input>
            </el-form-item>
            <el-form-item label="经销商编码"   class="h-elformWrap-2">
              <el-input v-model="f.agentCode" :v="f.agentCode" style="width:3.2rem" readonly></el-input>
            </el-form-item>
            <el-form-item label="年"  class="h-elformWrap-2">
              <el-input v-model="f.year" :v="f.year" style="width:3.2rem" readonly></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="h-formLine ">
          <!--展示表格-->
          <div class="h-table h-mrt30 sjwstyle">
            <el-table @selection-change="handleSelectionChange"
                      ref="ddtable"
                      :data="tableData"
                      stripe
                      style="width: 100%"
            >
              <el-table-column
                  type="index"
                  label="#"
                  fixed
                  width="40">
              </el-table-column>
              <!-- 审核状态列隐藏 -->
              <!--
              <el-table-column
                  prop="planStatus"
                  label="审核状态"
                  :show-overflow-tooltip="true"
                  width="120">
                <template slot-scope="scope">
                  {{scope.row.planStatus|dictname('fl_goal_approve_status')}}
                </template>
              </el-table-column>
              -->
              <el-table-column
                  prop="areaCode"
                  label="区域"
                  :show-overflow-tooltip="true"
                  fixed
                  width="90">
                <template slot-scope="scope">
                  {{scope.row.areaCode|dictname('YLRegion')}}
                </template>
              </el-table-column>
              <el-table-column
                  prop="salesRegionCode"
                  label="渠道"
                  :show-overflow-tooltip="true"
                  fixed
                  width="90">
                <template slot-scope="scope">
                  {{scope.row.salesRegionCode|dictname('sales_region')}}
                </template>
              </el-table-column>
              <el-table-column
                  prop="belongIndustryCode"
                  label="返利归属产业"
                  :show-overflow-tooltip="true"
                  fixed
                  width="100">
                <template slot-scope="scope">
                  {{scope.row.belongIndustryCode|dictname('fl_25_chain_group')}}
                </template>
              </el-table-column>
              <el-table-column
                  prop="rebateChainGroup"
                  label="签约链群"
                  :show-overflow-tooltip="true"
                  fixed
                  width="90">
                <template slot-scope="scope">
                  {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
                </template>
              </el-table-column>
              <el-table-column label="1月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal1Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal1Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal1"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal1!=null && scope.row.goal1 != scope.row.goal1Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal1}}</div>
                    <div v-if="scope.row.goal1==null || scope.row.goal1 == scope.row.goal1Old" style="text-align: right;">{{scope.row.goal1}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="2月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal2Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal2Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal2"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal2!=null && scope.row.goal2 != scope.row.goal2Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal2}}</div>
                    <div v-if="scope.row.goal2==null || scope.row.goal2 == scope.row.goal2Old" style="text-align: right;">{{scope.row.goal2}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="3月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal3Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal3Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal3"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal3!=null && scope.row.goal3 != scope.row.goal3Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal3}}</div>
                    <div v-if="scope.row.goal3==null || scope.row.goal3 == scope.row.goal3Old" style="text-align: right;">{{scope.row.goal3}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="4月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal4Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal4Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal4"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal4!=null && scope.row.goal4 != scope.row.goal4Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal4}}</div>
                    <div v-if="scope.row.goal4==null || scope.row.goal4 == scope.row.goal4Old" style="text-align: right;">{{scope.row.goal4}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="5月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal5Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal5Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal5"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal5!=null && scope.row.goal5 != scope.row.goal5Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal5}}</div>
                    <div v-if="scope.row.goal5==null || scope.row.goal5 == scope.row.goal5Old" style="text-align: right;">{{scope.row.goal5}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="6月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal6Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal6Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal6"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal6!=null && scope.row.goal6 != scope.row.goal6Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal6}}</div>
                    <div v-if="scope.row.goal6==null || scope.row.goal6 == scope.row.goal6Old" style="text-align: right;">{{scope.row.goal6}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="7月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal7Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal7Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal7"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal7!=null && scope.row.goal7 != scope.row.goal7Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal7}}</div>
                    <div v-if="scope.row.goal7==null || scope.row.goal7 == scope.row.goal7Old" style="text-align: right;">{{scope.row.goal7}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="8月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal8Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal8Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal8"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal8!=null && scope.row.goal8 != scope.row.goal8Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal8}}</div>
                    <div v-if="scope.row.goal8==null || scope.row.goal8 == scope.row.goal8Old" style="text-align: right;">{{scope.row.goal8}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="9月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal9Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal9Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal9"
                    :show-overflow-tooltip="true"
                    label="修改后目标(万元)"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal9!=null && scope.row.goal9 != scope.row.goal9Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal9}}</div>
                    <div v-if="scope.row.goal9==null || scope.row.goal9 == scope.row.goal9Old" style="text-align: right;">{{scope.row.goal9}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="10月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal10Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal10Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal10"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal10!=null && scope.row.goal10 != scope.row.goal10Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal10}}</div>
                    <div v-if="scope.row.goal10==null || scope.row.goal10 == scope.row.goal10Old" style="text-align: right;">{{scope.row.goal10}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="11月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal11Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal11Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal11"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal11!=null && scope.row.goal11 != scope.row.goal11Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal11}}</div>
                    <div v-if="scope.row.goal11==null || scope.row.goal11 == scope.row.goal11Old" style="text-align: right;">{{scope.row.goal11}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="12月" :show-overflow-tooltip="true">
                <el-table-column
                    prop="goal12Old"
                    label="旧目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{scope.row.goal12Old}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="goal12"
                    label="修改后目标(万元)"
                    :show-overflow-tooltip="true"
                    width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.goal12!=null && scope.row.goal12 != scope.row.goal12Old" style="text-align: right;color: red;font-weight: bold">{{scope.row.goal12}}</div>
                    <div v-if="scope.row.goal12==null || scope.row.goal12 == scope.row.goal12Old" style="text-align: right;">{{scope.row.goal12}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>


        </div>
      </div>
    </div>
    <div class="h-piece" style="margin:20px;padding: 0 0.26rem;">
      <div v-if="zstype" class="h-rowBox" style="margin-top:30px;">
        <div class="h-rowCon">
          <div class="h-pieceIn2">
            <div class="h-pieceTitle2" style="margin-left:10px;margin-bottom: 0.1rem;">
              <h1>审批意见</h1>
            </div>
            <div  class="h-table h-mrt30 h-rowBox gggg" style="margin-top: 0.2rem;">
              <div class="h-pieceTitle2">
                <el-form :model="formLabelAlign" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine inputO">
                  <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                                style="margin:0.2rem 0 0 0.2rem">
                    <el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"
                              class="zidaoO"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
      <div class="apprButton">
        <el-row>
          <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="cancel">返回</el-button>
          <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="refuse">驳回</el-button>
          <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
        </el-row>
      </div>
      <el-button v-if="!zstype"  @click="cancel" class="h-btn h-bBtn h-bgblueQ2">返回</el-button>
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
      <el-button v-if="!zstype"
                 size="small" class="h-btn h-bBtn h-bgblueQ2"
                 @click="genzongLiuch">
        跟踪审批
      </el-button>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'

export default {
  data() {
    return {
      instid:null,
      formLabelAlign:{},
      zstype:false,
      flaag: true,
      showhistory:false,
      f:{
        agentCode:null,
        year:null,
        agentName:null
      },
      //经销商名称
      AgentName: [],
      //table列表
      tableData: [],
      spform: {
        optflag:null,
        shpyj:null,
      },
      //表格
      multipleSelection: [],
    }
  },
  mounted() {
    this.query();
  },
  created() {
    this.query();
  },
  methods: {
    genzongLiuch(){
      this.showhistory = true;
    },
    query() {
      if(this.$route.query.taskstatus==0){
        this.zstype=true;
      }
      this.instid = this.$route.query.instid;
      ss.fanli.selectGoalShenpi(this.instid).then(rd => {
        this.tableData = rd;
        this.f.agentCode =rd[0].agentCode;
        this.f.agentName =rd[0].agentName;
        this.f.year =rd[0].year;
        this.f.area =rd[0].area;
      });
    },

    //取消提交
    cancel() {
      this.$router.back();
    },
    //通过按钮
    pass() {
      this.usercheck(2)
    },

    //驳回按钮
    refuse() {
      if(!this.formLabelAlign.checkMsg){
        this.$msg.msge("请填写审批意见");
      }else{
        this.usercheck(3)
      }
    },
    //返利合同审核
    usercheck(x) {
      var instid = this.$route.query.instid;
      var flagMsg = instid + "," + x +","+(this.formLabelAlign.checkMsg==null?" ":this.formLabelAlign.checkMsg)+","+this.$route.query.taskid;
      ss.fanli.checkFanliGoalXiugai(flagMsg).then(rd => {
        this.$store.dispatch('searchTasktotal');
        this.$msg.msgs("操作成功！");
        this.$router.back();
      });
    },
  }
}
</script>
<style scoped>
.h-tableInput .el-input {
  height: 100%;
}

.anniu {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}

</style>
<style>
.daoruhetong .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.8rem
}

.daoruhetong .h-formbLine .el-form-item__label {
  width: 40%;
}

.daoruhetong .h-formbLine .el-form-item__content {
  width: 60%;
}
.fltimeselect .el-date-editor.el-input__inner {
  width: 4rem;
}

.fltimeselect .el-form-item__content {
  line-height: 0.2rem;
}

.fltimeselect .el-date-editor .el-range-separator {
  width: 12%;
  line-height: 17px;
}

.fltimeselect .el-input__inner {
  padding-right: 0.1rem;
}
.gggg .h-formbLine .el-form-item__label {
  width: 23%
}

.gggg .h-formbLine .el-form-item__content {
  width: 77%
}
</style>
<style>
.sjwstyle .el-table thead.is-group th{
  background: #57aefe;
}
</style>
